import Vue from "vue"
import VueRouter from "vue-router"
import Login from "@/views/Login"
import store from "@/store"
Vue.use(VueRouter)

Vue.component("Login", Login)

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/utilizador",
    name: "utilizador",
    component: () => import("@/views/Utilizador.vue")
  },
  {
    path: "/brigada",
    name: "brigada",
    component: () => import("@/views/Brigada.vue")
  },
  {
    path: "/instituicao",
    name: "instituicao",
    component: () => import("@/views/Instituicao.vue")
  },
  {
    path: "/colheita",
    name: "colheita",
    component: () => import("@/views/Colheita.vue")
  },
  {
    path: "/dadiva",
    name: "dadiva",
    component: () => import("@/views/Dadiva.vue")
  },
  {
    path: "/galardao",
    name: "galardao",
    component: () => import("@/views/Galardao.vue")
  },
  {
    path: "/galardao_pedido",
    name: "galardao_pedido",
    component: () => import("@/views/Galardao_Pedido.vue")
  },
  {
    path: "/associado",
    name: "associado",
    component: () => import("@/views/Associado.vue")
  },
  {
    path: "/donativo",
    name: "donativo",
    component: () => import("@/views/Donativo.vue")
  },
  {
    path: "/notificacao",
    name: "notificacao",
    component: () => import("@/views/Notificacao.vue")
  },
  {
    path: "/termos",
    name: "termos",
    component: () => import("@/views/Termos.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (from.name != null) store.dispatch("session/checktoken")
  next()
})

export default router
